<template>
    <custom-dialog width="445px" :showClose="true" title="加工信息" v-if="visibleObj.processingDialog"
        :visible="visibleObj.processingDialog" @close="dialogVisible('processingDialog')" @save="comfirm">
        <div class="content" slot="content">
            <div class="pro-item" v-for="(item, index) in processList" :key="item.paymentRecipeId">
                <div class="checkbox">
                    <el-checkbox :true-label="'1'" :false-label="'0'" v-model="item.processFlag">中药处方{{ index + 1
                        }}</el-checkbox>
                </div>
                <el-form class="processingFrom" ref="form" label-position="left" :model="processingFrom"
                    label-width="80px">
                    <el-form-item label="加工方式">
                        <el-cascader :disabled="item.processFlag == '0' || item.isYlcp=='1'" style="width: 100%;"
                            :show-all-levels="false" v-model="item.process.processingValue" :options="options"
                            @change="handleChange($event, index)"></el-cascader>
                    </el-form-item>
                    <el-form-item label="袋数" class="bagNumber" v-if="item.process.processName == '熬药'">
                        <!-- <el-form-item label="袋数" v-if="processingFrom.processingValue[0] == '熬药'"> -->
                        <span>每付</span>
                        <el-input type="text" maxlength="5" :disabled="item.processFlag == '0'"
                            v-model.trim="item.process.bagNum" @change="bagNumberChange(item)"></el-input>
                        <span>袋，</span>
                        <span>共 <el-input type="text" maxlength="5" :disabled="item.processFlag == '0'"
                                v-model.trim="item.process.bagNumSum" @change="bagNumSumChange(item)"></el-input>
                            袋</span>
                    </el-form-item>
                    <el-form-item label="加工费">
                        <el-input @input="updateDataNum($event, item.process)"
                            v-model.trim="item.process.processPrice"></el-input>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input maxlength="100" :disabled="item.processFlag == '0'"
                            v-model.trim="item.process.remark"></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </custom-dialog>
</template>
  
<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import { processingPrice } from "@/api/processing"; // 获取加工请求
import { isNull, validParams, debounce,isArray } from '@/utils/validateBase';
import { Utils } from '@/utils/utils';
import { positiveInteger, positiveNum, positiveNum2 } from '@/utils/regexp'
export default {
    // 定义引入的组件
    components: { CustomDialog },
    props: {
        visibleObj: {
            type: Object,
            default: () => { return {} }
        },
        dialogObj: {
            type: Object,
            default: () => { return {} }
        },
    },
    data() {
        return {
            processList: [],//加工信息列表
            processingFrom: {},//加工信息
            options: [
                {
                    value: '熬药',
                    label: '熬药',
                },
                {
                    value: '制膏',
                    label: '制膏',
                },
                {
                    value: '制丸',
                    label: '制丸',
                    children: [
                        {
                            value: '蜜丸',
                            label: '蜜丸',
                        },
                        {
                            value: '水丸',
                            label: '水丸',
                        },
                    ]
                },
                {
                    value: '制粉',
                    label: '制粉',
                    children: [
                        {
                            value: '粗粉',
                            label: '粗粉',
                        },
                        {
                            value: '细粉',
                            label: '细粉',
                        },
                    ]
                },
                {
                    value: '加工-YL',
                    label: '加工-YL',
                    disabled:true
                },

            ],
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    created() {
        let list = _.cloneDeep(this.dialogObj.recipesList)
        this.processList = list.filter(item => { return item.recipeType == '1' })
        if (Utils.eq(this.processList.length, 1)) {
            let item = this.processList[0]
            if (item.processFlag == '1') {
                if (isNull(item.process.processingValue)) {
                    switch (item.process.processName) {
                        case '蜜丸':
                            item.process.processingValue = ['制丸', '蜜丸'];
                            break;
                        case '水丸':
                            item.process.processingValue = ['制丸', '水丸'];
                            break;
                        case '粗粉':
                            item.process.processingValue = ['制粉', '粗粉'];
                            break;
                        case '粗粉':
                            item.process.processingValue = ['制粉', '粗粉'];
                            break;
                        default:
                            item.process.processingValue = []
                            item.process.processingValue[0] = item.process.processName
                            break;
                    }

                } else {
                    if(_.isString(item.process.processingValue)){
                        item.process.processingValue = JSON.parse(item.process.processingValue)
                    }
                }
            } else {
                item.processFlag = '1'
                item.process = {
                    bagNum: '3',
                    bagNumSum: this.$bigNumber(3, '*', item.doseNum),
                    paymentRecipeId: item.paymentRecipeId,
                    processName: '熬药',
                    processPrice: '0',
                    processingValue: ['熬药'],
                    remark: ''
                }
                this.processList[0] = item
                this.getProcessingPrice(item.process, item.doseNum, item.weight)
            }
        } else {
            this.processList.forEach(item => {
                if (item.processFlag && item.processFlag == '1') {
                    if (isNull(item.process.processingValue)) {
                        switch (item.process.processName) {
                            case '蜜丸':
                                item.process.processingValue = ['制丸', '蜜丸'];
                                break;
                            case '水丸':
                                item.process.processingValue = ['制丸', '水丸'];
                                break;
                            case '粗粉':
                                item.process.processingValue = ['制粉', '粗粉'];
                                break;
                            case '粗粉':
                                item.process.processingValue = ['制粉', '粗粉'];
                                break;
                            default:
                                item.process.processingValue = []
                                item.process.processingValue[0] = item.process.processName
                                break;
                        }

                    } else {
                        if(_.isString(item.process.processingValue)){
                            item.process.processingValue = JSON.parse(item.process.processingValue)
                        }
                    }
                } else {
                    item.processFlag = '0'
                    item.process = {
                        bagNum: '3',
                        bagNumSum: this.$bigNumber(3, '*', item.doseNum),
                        paymentRecipeId: item.paymentRecipeId,
                        processName: '熬药',
                        processPrice: '0',
                        processingValue: ['熬药'],
                        remark: ''
                    }
                    this.getProcessingPrice(item.process, item.doseNum, item.weight)
                }
            })
        }

    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    computed: {

    },
    // 页面方法
    methods: {
        /**
         * 加工费改变
         */
        updateDataNum: debounce(function (val, obj) {
            let bol = validParams(val, positiveNum, '请输入数字,保留两位小数,长度不能超过6位')
            if (bol) {

            } else {
                obj.processPrice = ''
            }
        }, 400),

        /**
         * 加工方式改变
         */
        handleChange(val, index) {
            let processItem = this.processList[index].process
            let { doseNum, weight } = this.processList[index]
            let length = val.length
            let processName = val[length - 1]
            processItem.processName = processName
            if (processName == '熬药') {
                processItem.bagNum = '3'
                processItem.bagNumSum = this.$bigNumber(processItem.bagNum, '*', doseNum)
            } else {
                processItem.bagNum = '0'
                processItem.bagNumSum = '0'
            }
            this.getProcessingPrice(processItem, doseNum, weight)
        },
        /**
         * 获取加工费
         */
        getProcessingPrice(processItem, doseNum, weight) {
            let { bagNumSum, processName } = processItem
            let params = {
                number: doseNum,
                processingType: processName,
                weight: this.$bigNumber(weight, '*', doseNum),
                bagNumberSum: bagNumSum
            }
            if (processName != '熬药') params.bagNumber = '0'
            processingPrice(params).then(res => {
                if (res.code == 200) {
                    processItem.processPrice = res.data
                }
            })
        },

        /**
         * 确定
         */
        comfirm() {
            let index = this.processList.findIndex(item => { return item.processFlag == '1' })
            let priceIndex = this.processList.findIndex(item => { return item.processFlag == '1' && isNull(item.process.processPrice) })
            if (Utils.gt(priceIndex, -1)) return this.$message.error('请选择输入加工费')
            if (Utils.eq(index, -1)) return this.$message.error('请选择需要加工的处方')
            let list = _.cloneDeep(this.dialogObj.recipesList)
            for (let i = 0; i < list.length; i++) {
                for (let j = 0; j < this.processList.length; j++) {
                    if (list[i].paymentRecipeId == this.processList[j].paymentRecipeId) list[i] = this.processList[j]
                }

            }
            list.forEach(item => {
                if (item.recipeType == '1' && isArray(item.process.processingValue)) item.process.processingValue = JSON.stringify(item.process.processingValue)
            })
            this.$emit('updateData', list)
        },
        /**
        * 关闭
        */
        dialogVisible(name) {
            this.$emit("close", name);
        },
        /**
         * 输入框改变
         */
        bagNumberChange(item) {
            let bol = validParams(item.process.bagNum, positiveNum2, '请输入正确的正数，最多2位小数')
            if (bol) {
                item.process.bagNumSum =Math.ceil(this.$bigNumber(item.process.bagNum, '*', item.doseNum)) ;//向上取整
                this.getProcessingPrice(item.process, item.doseNum, item.weight)
            } else {
                item.process.bagNum = 3
            }
        },
        /**
         * 总袋数改变
         */
        bagNumSumChange(item) {
            let bol = validParams(item.process.bagNumSum, positiveInteger, '请输入正整数')
            if (bol) {
                item.process.bagNum = this.$bigNumber(item.process.bagNumSum, '/', item.doseNum, 2)
                this.getProcessingPrice(item.process, item.doseNum, item.weight)
            } else {
                item.process.bagNum = this.$bigNumber(item.process.bagNum, '*', item.doseNum)
            }
        },
    },
}
</script>
<style lang="less" scoped>
/deep/.dialog-content {
    max-height: 520px;
}

.content {
    /deep/.el-input.is-disabled .el-input__inner {
        // background: #fff;
        // color: #606266;
    }

    .pro-item {
        margin-top: 18px;
        border-bottom: 1px solid #EBEAEE;

        &:last-child {
            border-bottom: none;
        }

        &:first-child {
            margin-top: 0;
        }

        .checkbox {
            padding-bottom: 18px;
            border-bottom: 1px dashed #EBEAEE;
        }

        .processingFrom {
            margin-top: 16px;

            .el-form-item {
                margin-bottom: 12px;
            }

            .bagNumber {
                .el-input {
                    width: 80px;

                    /deep/.el-input__inner {
                        border: none;
                        padding: 0;
                        border-bottom: 1px solid #E1E1E1;
                        text-align: center;

                    }
                }
            }
        }
    }
}
</style>